import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'appControlError',
})
export class ControlErrorPipe implements PipeTransform {
  transform(errors: any) {
    if (errors?.required) return 'Requerido';
    return Object.values(errors || {})?.find(e => typeof e === 'string') || '';
  }
}
